export default "__VITE_ASSET__DvV77vey__"